import React, {Fragment} from "react";
import image from '../../../images/situation/maten/kozijn/A.gif'

export default function MaatA(props) {
    return <Fragment>
        <div className="addtextMore">
            Hier kunt u invullen wat de maat is tussen het gesloten luik en het kozijn, in milimeters.
            <br />
            <br />
            Deze maat zal meestal 2 of 3 mm zijn. Alleen als bijvoorbeeld ramen of scharnieren er buiten uitsteken, zal deze maat groter zijn.
            <br />
            <br />
            Houd ook rekening met eventuele deurkrukken.
        </div>
        <img className="explainImage" src={image} alt=""/>
    </Fragment>;
}